import { createAction } from 'redux-actions'

import * as constants from './constants'

export const setJobTitle = createAction(constants.SET_JOB_TITLE)
export const setCompanyName = createAction(constants.SET_COMPANY_NAME)
export const setCompanyUrl = createAction(constants.SET_COMPANY_URL)
export const setHandle = createAction(constants.SET_HANDLE)

export const createProfile = createAction(constants.CREATE_PROFILE)
export const createProfileSuccess = createAction(constants.CREATE_PROFILE_SUCCESS)
export const createProfilePending = createAction(constants.CREATE_PROFILE_PENDING)
export const createProfileFailed = createAction(constants.CREATE_PROFILE_FAILED)

export const updateProfile = createAction(constants.UPDATE_PROFILE)
export const updateProfileSuccess = createAction(constants.UPDATE_PROFILE_SUCCESS)
export const updateProfilePending = createAction(constants.UPDATE_PROFILE_PENDING)
export const updateProfileFailed = createAction(constants.UPDATE_PROFILE_FAILED)

export const fetchProfile = createAction(constants.FETCH_PROFILE)
export const fetchProfileSuccess = createAction(constants.FETCH_PROFILE_SUCCESS)
export const fetchProfilePending = createAction(constants.FETCH_PROFILE_PENDING)
export const fetchProfileFailed = createAction(constants.FETCH_PROFILE_FAILED)

export const checkUniqueHandle = createAction(constants.CHECK_UNIQUE_HANDLE)
export const checkUniqueHandleSuccess = createAction(constants.CHECK_UNIQUE_HANDLE_SUCCESS)
export const checkUniqueHandleFailed = createAction(constants.CHECK_UNIQUE_HANDLE_FAILED)

export const uploadCoverPhoto = createAction(constants.UPLOAD_COVER_PHOTO)
export const uploadCoverPhotoSuccess = createAction(constants.UPLOAD_COVER_PHOTO_SUCCESS)
export const uploadCoverPhotoPending = createAction(constants.UPLOAD_COVER_PHOTO_PENDING)
export const uploadCoverPhotoFailed = createAction(constants.UPLOAD_COVER_PHOTO_FAILED)




// WEBPACK FOOTER //
// ./src/modules/profile/actions.js